module.exports = __webpack_public_path__ + "static/media/cryptocoins.fa16c0d7.ttf";